<template>
  <div class="content" v-if="selectedRows && selectedRows[0] && selectedRows[0].data">
    <ed-title-nav class="title-nav" :title="title">
      <span v-if="!this.$user.$.userPermissions.includes('ApprovalDashboard')" slot="action">
        <a href="javascript:;" @click="envelope.FromDashboard || $route.query.IsApproveEnvelopeFromEmail=='true' || $route.query.IsRejectEnvelopeFromEmail=='true' ? ($emit('backToTransactions'), goToDashboard()) : $emit('backToTransactions')">
          <i class="fa fa-long-arrow-left"></i>
          <span> &nbsp; {{ $t('BACK') + ' ' + $t('TO') + ' ' + (envelope.FromDashboard || $route.query.IsApproveEnvelopeFromEmail=='true' || $route.query.IsRejectEnvelopeFromEmail=='true' ? $t('DASHBOARD') : (editEnvelope ? $t('ENVELOPES') : $t('TRANSACTIONS'))) + ' ' + $t($route.query['back-to']) }}</span>
        </a>
      </span>

      <div slot="overview" class="row content">
        <div class="summary well small col-md-offset-6 col-md-6">
          <table class="col-md-12">
            <thead>
              <tr>
                <td>Transactions</td>
                <td>Amount</td>
              </tr>
            </thead>
            <tfoot>
              <tr>
                <td>Transactions</td>
                <td>Amount</td>
              </tr>
            </tfoot>
            <tbody>
              <tr>
                <td>
                  <strong>{{ selectedRows.length }}</strong>
                </td>
                <td>
                  <v-money currency="USD" locale="en">{{ calculatedTotalAmount.toFixed(2) }}</v-money>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="clear" />
        </div>
      </div>

      <!-- Action Buttons -->
      <TheToolbar slot="toolbar">
        <ed-button class="btn btn-actionbar"
                   v-if="!readonly"
                   :disabled="preventCreateEnvelope"
                   @click="createEnvelope(false)">
          SAVE DRAFT
        </ed-button>
        <ed-button button-class="btn btn-actionbar"
                   v-if="!readonly"
                   class="alt"
                   :disabled="preventCreateEnvelope"
                   @click="createEnvelope(true)">
          SUBMIT
        </ed-button>
        <ed-button button-class="btn btn-actionbar"
                   class="alt"
                   v-if="isApprover && readonly"
                   @success="refresh"
                   :disabled="preventCreateEnvelope"
                   @click="validateBeforeApprove">
          Approve
        </ed-button>
        <RejectEnvelope v-if="isApprover && readonly"
                        :envelope="envelope"
                        :disabled="preventCreateEnvelope"
                        @success="envelope.FromDashboard ? ($emit('backToTransactions'), goToDashboard()) : $emit('backToTransactions')" />
      </TheToolbar>

    </ed-title-nav>

    <div class="container-fluid" title="">
      <ed-section class="page-section active clear">
        <div class="notice-alert-container">
          <ed-notice v-if="receiptIncomplete && !hasIncompleteField"
                     class="notice-alert"
                     type="danger"
                     message="Please attach a receipt for every transaction."
                     icon="fas fa-exclamation-triangle" />
        </div>
        <div class="reject-reason-container col-md-12">
          <ed-notice v-if="rejectedStatuses.includes(envelope.EnvelopeStatus)"
                     class="reject-reason-alert"
                     type="danger"
                     icon="fas fa-exclamation-triangle">
            <span v-html="rejectionMessage" />
          </ed-notice>
        </div>
        <div class="notice-alert-container">
          <ed-notice v-if="(hasIncompleteField && !receiptIncomplete) || (hasIncompleteField && receiptIncomplete)"
                     class="notice-alert"
                     type="danger"
                     message="Please complete all required fields"
                     icon="fas fa-exclamation-triangle" />
        </div>
        <div class="notice-alert-container">
          <ed-notice v-if="hasDuplicates"
                     class="notice-alert"
                     type="danger"
                     icon="fas fa-exclamation-triangle">
            <span v-html="duplicateMessage" />
          </ed-notice>
        </div>
        <div class="col-md-12 no-pad">
          <div class="col-md-12 no-pad">
            <h4>Envelope Information</h4>
          </div>
          <div class="col-md-12">
            <table class="full-width-table small">
              <thead>
                <tr>
                  <th class="col-md-2">Card Holder:</th>
                  <th class="col-md-2">Card Number:</th>
                  <th class="col-md-2">Production:</th>
                  <th class="col-md-2">{{ programName }}:</th>
                  <th class="col-md-2">Envelope No:</th>
                  <th class="col-md-2">Date:</th>
                  <th class="col-md-2">Status:</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="col-md-2">{{ selectedRows[0].data.Holder }}</td>
                  <td class="col-md-2"> *{{ selectedRows[0].data.CardNumber }}</td>
                  <td class="col-md-2">{{ selectedRows[0].data.Division }}</td>
                  <td class="col-md-2">
                    <ed-select :placeholder="`Select a ${ programName.toLowerCase() }...`"
                               :options="programLoader.items"
                                track-by="Id"
                                v-model="selectedProgram"
                                :checkboxes="false"
                                :customLabel="option => option && option.Name ? (option.InternalProgramID ? `${option.Name} (${option.InternalProgramID})` : option.Name) : ''"
                                @open="onSelectProgramOpen"
                                server-search
                                @search="onProgramSearch"
                                @scroll-bottom="() => loadPrograms(false)"
                                name="program"
                                :error="programIncomplete"
                                @input="handleProgramInput"
                                class="custom-dropdown"
                                :disabled="!isApprover && readonly" />
                  </td>
                  <td class="col-md-2">{{ envelope && envelope.EnvelopeNumber || '' }}</td>
                  <td class="col-md-2">
                    {{ getDateFromFormatedDate(envelope && envelope.FormattedLastModifiedDate) }}
                    <br>
                    <span v-if="draftSaved" style="font-style: italic; font-size: smaller;">Draft Saved {{ getTimeFromFormatedDate(envelope && envelope.FormattedLastModifiedDate) }}</span>
                  </td>
                  <td class="col-md-2">{{ envelope && envelope.EnvelopeStatus || '' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="clear"></div>
          <hr />
          <h4>Transactions</h4>
          <div class="col-md-12 -scroll">
            <div class="table-container small" xstyle="{ width: `${1140 + formFields.length * 50}px` }">
              <div class="table-row header col-md-12 no-pad">
                <div class="col-md-6 no-pad">
                  <div class="col-md-1 id-row"><strong>#</strong></div>
                  <div class="col-md-2"><strong>Date</strong></div>
                  <div class="col-md-3"><strong>Merchant</strong></div>
                  <div class="col-md-3 supplier-column"><strong>Supplier</strong></div>
                  <div class="col-md-2 amount-column"><strong>Amount</strong></div>
                </div>
                <div class="col-md-6 no-pad" xstyle="extraColumnsStyle">
                  <div class="col-md-2"><strong>Description</strong></div>
                  <div v-if="hasBu && !hasBuAndCcPair" class="col-md-3"><strong>Business Unit</strong></div>
                  <div v-if="hasCc && !hasBuAndCcPair" :class="`col-md-${hasBu ? 2 : 3}`"><strong>Cost Center</strong></div>
                  <div v-if="hasBuAndCcPair" class="col-md-3"><strong>BU/CC</strong></div>
                  <div :class="`col-md-${hasBu && hasCc ? 3 : 4}`"><strong>Category</strong></div>
                  <div :class="`col-md-${hasBu && hasCc ? 2 : 3}`"><strong>Category Ref ID</strong></div>
                </div>
              </div>
              <div class="col-md-12 no-pad"
                   v-for="(selectedRow, index) in selectedRows"
                   :key="index"
                   :class="{ 'red-border': duplicateIndexesMap[index] !== undefined }">
                <div class="col-md-6 no-pad">
                  <div class="col-md-1 id-row">{{ index + 1 }}</div>
                  <div class="col-md-2">{{ formatDate(selectedRow.data.TransactionDate) }}</div>
                  <div class="col-md-3 column-overflow" v-tooltip.bottom='selectedRow.data.Merchant'>{{ selectedRow.data.Merchant }}</div>
                  <div class="col-md-3 supplier-column">
                    <ed-select :placeholder="getSupplierPlaceholder(index)"
                               :options="supplierOptions"
                               v-model="selectedSuppliers[index]"
                               :value="selectedSuppliers[index]"
                               :checkboxes="false"
                               :customLabel="getLabel"
                               required
                               @open="fetchSuppliersOnOpen"
                               @search="fetchSuppliers"
                               server-search
                               @select="getSelectedSupplier"
                               name="supplier"
                               @input="(option) => handleSupplierSelection(option, index)"
                               class="custom-dropdown-supplier inline"
                               :error="supplierIncomplete[index]"
                               :disabled="!isApprover && readonly">
                      <template slot='option'
                                slot-scope='props'>
                        <ed-select-options thumbnails>
                          <div slot='row1' class="option-combo-img">
                            <img slot='image' :src='props.option.Value.Logo' width='48' />
                          </div>
                          <div slot='row2' class="no-wrap">
                            <span class="option-strong"> <strong>{{ he.decode(props.option.Value.CompanyName) }} </strong> </span>
                            <em class="option-em">({{props.option.Value.Vci}})</em>
                            <br />
                            <span v-if='props.option.Value.SupplierName' class="option-bold"> {{ he.decode(props.option.Value.SupplierName) }}</span>
                            <span v-if='props.option.Value.SupplierRequestedName'>
                              <br />
                              <i>{{ props.option.Value.SupplierRequestedName }}</i>
                            </span>
                            <span v-if='props.option.Value.CountryName'>
                              <br />
                              <span class="fas fa-map-marker-alt contact-icon"></span> &nbsp;{{ props.option.Value.City + (props.option.Value.State != '' && props.option.Value.State != null ? ' ' + props.option.Value.State : (props.option.Value.Region != '' && props.option.Value.Region != null ? ' ' + props.option.Value.Region : '')) + ' ' + props.option.Value.CountryName }}
                            </span>
                            <span v-if='props.option.Value.BusinessType'>
                              <br />
                              <span class="fas fa-briefcase contact-icon"></span> &nbsp;{{ props.option.Value.BusinessType }}
                            </span>
                            <span v-if='props.option.Value.SupplierEmail'>
                              <br />
                              <span class="fas fa-envelope contact-icon">
                              </span> &nbsp;{{ props.option.Value.SupplierEmail }}
                            </span>
                            <br />
                            <span v-if='props.option.Value.IsEvedPay' class="label supplier-evedpay">EvedPay Ready</span>
                            <span v-if='props.option.Value.VendorType' class="label" :class="[`supplier-type-${props.option.Value.VendorType}`]">{{ props.option.Value.VendorType }} Supplier</span>
                          </div>
                        </ed-select-options>
                      </template>
                    </ed-select>
                  </div>
                  <!-- amount here -->
                  <div class="col-md-2 amount-column">
                    <v-money currency="USD" locale="en">{{ selectedRow.data.Amount.toFixed(2) }}</v-money>
                  </div>
                </div>
                <div class="col-md-6 no-pad description-col" xstyle="extraColumnsStyle">
                  <div class="col-md-2 description-field">
                    <ed-input type='text'
                              v-model="descriptions[index]"
                              class="description-textbox small"
                              :error="descriptionIncomplete[index]"
                              @input="descriptionIncomplete[index] = false"
                              :disabled="!isApprover && readonly" />
                  </div>
                  <div class="col-md-1 remove-line">
                    <button @click="removeTransaction(index)" v-if="selectedRows.length > 1 && (isApprover || !readonly)" class="remove-button">
                      <i class="fas fa-times-circle"></i>
                    </button>
                  </div>
                </div>
                <div v-if="form" v-for="(row, rowIndex) in selectedRow.form" :key="`form-row-${index}-${rowIndex}-${splitCounters[index]}`" class="table-row">
                  <div class="table-row">
                    <div class="col-md-6 no-pad">
                      <div class="col-md-1 id-row">&nbsp;</div>
                      <div class="col-md-5">
                        <span v-if="rowIndex != 0">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                        <AddReceipt v-if="rowIndex == 0"
                                    @attachmentsUpdated="(files) => updateAttachmentsFiles(files, index)"
                                    :rowData="selectedRow.data"
                                    :incomplete="attachmentIncomplete[index]"
                                    :attachments="attachments[index]"
                                    :disabled="!isApprover && readonly"
                                    :isDraft="envelope && envelope.EnvelopeStatus && envelope.EnvelopeStatus === 'Draft'" />
                        &nbsp;
                        <a class="row-action"
                           href="javascript:;"
                           @click="(!selectedProgram || Object.keys(selectedProgram).length === 0) ? showWarningMessage() : toggleSplit(index, rowIndex, selectedRow)"
                           v-if="isApprover || !readonly">
                          +Split
                        </a>
                        &nbsp;
                        <a class="row-action"
                           href="javascript:;"
                           @click="copySplit(row)"
                           v-if="isApprover || !readonly">
                          Copy
                        </a>
                        &nbsp;
                        <a class="row-action"
                           href="javascript:;"
                           @click="pasteSplit(index, row)"
                           v-if="isApprover || !readonly">
                          Paste
                        </a>
                        &nbsp;
                        <a class="row-action"
                           href="javascript:;"
                           @click="removeSplit(index, rowIndex, selectedRow)"
                           v-if="(isApprover || !readonly) && splitCounters[index] > 1">
                          Remove
                        </a>
                      </div>
                      <!-- amount here -->
                      <div class="col-md-2 amount-column">
                        <ed-input v-if="splitCounters[index] > 1"
                                  amount
                                  type="money"
                                  class="amount-input"
                                  v-model="row.Amount"
                                  :key="`amount-input-${index}-${rowIndex}-${splitCounters[index]}`"
                                  :error="wrongSplitTotal[index]"
                                  @input="handleSplitAmounts(index)"
                                  :disabled="!isApprover && readonly" />
                        <v-money v-else currency="USD" locale="en">{{ selectedRow.data.Amount.toFixed(2) }}</v-money>
                      </div>
                    </div>
                    <div class="col-md-6 no-pad" xstyle="extraColumnsStyle">
                      <!-- standard fields -->
                      <div class="extra-row">
                        <div class="col-md-2">&nbsp;</div>
                        <div class="col-md-3" v-if="hasBu && !hasBuAndCcPair">
                          <ed-select v-tooltip="(!selectedProgram || Object.keys(selectedProgram).length === 0)
                          ? `Please select a ${ programName.toLowerCase() } first`
                          : businessUnits.length === 0
                            ? `Please add Business Units to the selected ${ programName.toLowerCase() } before proceeding`
                            : ''"
                                     placeholder="Select a BU..."
                                     :options="businessUnits"
                                     v-model="row.BusinessUnit"
                                     :value="row.BusinessUnit"
                                     :checkboxes="false"
                                     label="name"
                                     track-by="businessUnitId"
                                     name="bu"
                                     @input="(value) => handleInput(index, rowIndex, 'BusinessUnit', value)"
                                     class="custom-dropdown-supplier no-margin inline"
                                     :error="row.BusinessUnit == null && buIncomplete[index]"
                                     :disabled="((!selectedProgram || Object.keys(selectedProgram).length === 0) || businessUnits.length === 0) || (!isApprover && readonly)" />
                        </div>
                        <div :class="`col-md-${hasBu ? 2 : 3}`" v-if="hasCc && !hasBuAndCcPair">
                          <ed-select v-tooltip="(!selectedProgram || Object.keys(selectedProgram).length === 0)
                          ? `Please select a ${ programName.toLowerCase() } first`
                          : costCenters.length === 0
                            ? `Please add Cost Centers to the selected ${ programName.toLowerCase() } before proceeding`
                            : ''"
                                     placeholder="Select a CC..."
                                     :options="costCenters"
                                     v-model="row.CostCenter"
                                     :value="row.CostCenter"
                                     :checkboxes="false"
                                     :custom-label="(o) => `${o.code} (${o.name})`"
                                     track-by="costCenterId"
                                     name="cc"
                                     @input="(value) => handleInput(index, rowIndex, 'CostCenter', value)"
                                     class="custom-dropdown-supplier inline"
                                     :error="row.CostCenter == null && ccIncomplete[index]"
                                     :disabled="((!selectedProgram || Object.keys(selectedProgram).length === 0) || costCenters.length === 0) || (!isApprover && readonly)" />
                        </div>
                        <div class="col-md-3" v-if="hasBuAndCcPair">
                          <ed-select v-tooltip="(!selectedProgram || Object.keys(selectedProgram).length === 0)
                          ? `Please select a ${ programName.toLowerCase() } first`
                          : buAndCcPairs.length === 0
                            ? `Please add BUs & CCs to the selected ${ programName.toLowerCase() } before proceeding`
                            : ''"
                                     placeholder="Select BU & CC..."
                                     :options="buAndCcPairs"
                                     v-model="row.BuAndCcPair"
                                     :value="row.BuAndCcPair"
                                     :checkboxes="false"
                                     label="name"
                                     track-by="programBusinessUnitAndCostCenterId"
                                     name="pair"
                                     @input="(value) => handleInput(index, rowIndex, 'BuAndCcPair', value)"
                                     class="custom-dropdown-supplier inline"
                                     :error="row.BuAndCcPair == null && buAndCcPairIncomplete[index]"
                                     :disabled="((!selectedProgram || Object.keys(selectedProgram).length === 0) || buAndCcPairs.length === 0) || (!isApprover && readonly)" />
                        </div>
                        <div :class="`col-md-${hasBu && hasCc ? 3 : 4}`">
                          <ed-select v-tooltip="(!selectedProgram || Object.keys(selectedProgram).length === 0)
                          ? `Please select a ${programName.toLowerCase()} first`
                          : categories.length === 0
                            ? `Please assign Categories to the ${divisionName.toLowerCase()} of the selected ${ programName.toLowerCase() } before proceeding`
                            : ''"
                                     placeholder="Select a Category..."
                                     :options="categories"
                                     v-model="row.Category"
                                     :value="row.Category"
                                     :checkboxes="false"
                                     track-by="key"
                                     label="text"
                                     name="category"
                                     @input="(value) => {
                          handleInput(index, rowIndex, 'Category', value)
                          row.ReferenceId = value !== null ? value.referenceId : null
                          $forceUpdate()
                        }"
                                     class="custom-dropdown-supplier inline"
                                     :error="row.Category == null && categoryIncomplete[index]"
                                     :disabled="((!selectedProgram || Object.keys(selectedProgram).length === 0) || categories.length === 0) || (!isApprover && readonly)" />
                        </div>
                        <div :class="`col-md-${hasBu && hasCc ? 2 : 3}`">
                          <ed-input v-tooltip="(!selectedProgram || Object.keys(selectedProgram).length === 0)
                          ? `Please select a ${ programName.toLowerCase() } first`
                          : categories.length === 0
                            ? `Please assign Categories to the ${ divisionName.toLowerCase() } of the selected ${ programName.toLowerCase() } before proceeding`
                            : !row.Category ? `Please select a category first` : ''"
                                    class="small-input"
                                    placeholder="Category Ref ID..."
                                    v-model="row.ReferenceId"
                                    :value="row.ReferenceId"
                                    @input="(value) => handleInput(index, rowIndex, 'ReferenceId', value)"
                                    :disabled="((!selectedProgram || Object.keys(selectedProgram).length === 0) || categories.length === 0 || !row.Category) || (!isApprover && readonly)"
                                    maxlength="50" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- custom fields -->
                  <div class="table-row">
                    <div v-if="formFields && formFields.length > 0" class="table-row">
                      <div class="col-md-12">
                        <div v-for="(field, index) in formFields" :key="index" :class="['no-pad', field.Type === 'select' ? 'col-md-2' : 'col-md-1']">
                          <span>{{ field.Label }}</span>
                        </div>
                      </div>
                    </div>
                    <div v-if="formFields && formFields.length > 0" class="table-row">
                      <div class="col-md-12">
                        <div v-for="(field, fieldIndex) in row" :class="['no-pad', field.Type === 'select' ? 'col-md-2' : 'col-md-1']">
                          <input v-if="field.Type !== 'select'"
                                 type="text"
                                 class="form-control"
                                 v-model="field.Values"
                                 :class="{ 'input-error': isCustomFieldInvalid(field, index) }"
                                 :disabled="!isApprover && readonly" />
                          <ed-select v-if="field.Type === 'select'"
                                     :placeholder="`${ field.Label }...`"
                                     :options="customOptions[field.Key]"
                                     track-by="value"
                                     v-model="field.Values"
                                     :checkboxes="false"
                                     label="text"
                                     name="program"
                                     :class="['custom-field-dropdown', { 'input-error': isCustomFieldInvalid(field, index) }]" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-12 no-pad">
          <p class="total-amount">Total amount: <v-money currency="USD" locale="en">{{ calculatedTotalAmount.toFixed(2) }}</v-money></p>
          <AddTransaction v-if="isApprover || !readonly"
                          @transaction="handleTransaction"
                          :selectedRows="selectedRows"
                          :selectedProgram="selectedProgram"
                          :envelopeId="envelope && envelope.Id" />
        </div>
        <hr>
        <div v-if="(Approvers && Approvers.length > 0) || (ApprovalNeeded && ApprovalNeeded.length > 0)" class=" col-md-6">
          <h5>Approval</h5>
          <table class="table table-striped">
            <thead>
              <tr>
                <th class="col-md-2" style="width: 20%;">Approval:</th>
                <th class="col-md-2" style="width: 20%;">When:</th>
                <th class="col-md-5" style="width: 40%;">Approver:</th>
                <th class="col-md-3" style="width: 20%;">Reason:</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="approver in Approvers">
                <td v-if="!approver.Reason" class="col-md-2">Approved</td>
                <td v-if="approver.Reason" class="col-md-2" style="color: red;">Declined</td>
                <td class="col-md-2">{{  formatDate(approver.CreatedDate) }}</td>
                <td class="col-md-5">{{ approver.User.Name }}</td>
                <td v-if="approver.Reason" class="col-md-3">
                  <a href="javascript:;" style="margin-bottom: 10px;" v-tooltip="'Click to see decline reason'">
                    <i class="fas fa-book" style="color: red;" href="javascript:;" @click="handleReasonClick(approver)"></i>
                  </a>
                </td>
              </tr>
              <tr v-for="approval in ApprovalNeeded">
                <td class="col-md-2" style="font-style: italic;">Pending...</td>
                <td class="col-md-2">{{ formatDate(approval.CreatedDate) }}</td>
                <td class="col-md-5">{{ approval.Name }}</td>
                <td class="col-md-3"></td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="4" style="border-top: 1px solid #dee2e6;"></td>
              </tr>
            </tfoot>
          </table>

          <ed-button v-if="envelope && waitingApprovalStatuses.includes(envelope.EnvelopeStatus)"
                     button-class="btn btn-actionbar"
                     class="alt"
                     :disabled="isResendButtonDisabled"
                     @click="handleResend">
            RESEND
          </ed-button>
          <span v-if="resendMessage" class="resend-message">{{ resendMessage }}</span>
        </div>
        <div class="col-md-12"></div>
        <ed-button button-class="btn centered-submit"
                   class="alt"
                   v-if="!readonly"
                   :disabled="preventCreateEnvelope"
                   @click="createEnvelope(true)">
          SUBMIT
        </ed-button>
        <div v-if="isApprover && readonly"
             class="centered-approval">
          <ed-button button-class="btn btn-actionbar bigger"
                     class="alt"
                     @success="refresh"
                     :disabled="preventCreateEnvelope"
                     @click="validateBeforeApprove">
            Approve
          </ed-button>
          <RejectEnvelope :envelope="envelope"
                          :disabled="preventCreateEnvelope"
                          @success="envelope.FromDashboard ? ($emit('backToTransactions'), goToDashboard()) : $emit('backToTransactions')" />
        </div>
      </ed-section>
    </div>
    <ed-modal title="Caution"
              :show="showAlertProgram"
              @close="showAlertProgram = false, selectedProgram = programConfirmPressed ? programOption : previousSelectedProgram, programConfirmPressed = false"
              @confirm="handleProgramChange(programOption), programConfirmPressed = true"
              :primary-button="'YES'"
              :secondary-button="'NO'">
      <div slot="body">
        <p class="small">Changing the {{programName}} will delete all the split items. Are you sure you want to change the it?</p>
      </div>
    </ed-modal>
    <ApproveDialog v-if="(envelope && waitingApprovalStatuses.includes(envelope.EnvelopeStatus)) || ($route.query.IsApproveEnvelopeFromEmail=='true')"
                   :showModal="showApproveDialog"
                   :list="transformRows(envelope)"
                   :programLabel="programLabel"
                   :loading="isApproving"
                   envelopeApproval
                   @approve="doApprove"
                   @close="() => { showApproveDialog = false }" />
    <ed-modal title="Envelope Decline Reason" :show="showEnvelopeRejectInfo" @close="showEnvelopeRejectInfo = false" primary-button="Close" secondary-button="false">
      <EnvelopeRejectInfo slot="body" :rejectionReason="rejectionReason" />
    </ed-modal>
    <RejectDialog :showModal="showRejectDialog"
                  :list="transformRows(envelope)"
                  :rejectText="'Decline'"
                  :programLabel="programLabel"
                  :divisionLabel="divisionLabel"
                  @reject="doReject"
                  :submitEndpoint="submitEndpoint"
                  @close="() => { showRejectDialog = false }" />
  </div>
</template>
<script>

  import TheToolbar from '@/components/_modules/I2P/components/TheToolbar'
  import AddTransaction from './AddTransactionInEnvelope.vue'
  import RejectEnvelope from '@/components/_modules/Programs/Card-envelopes/RejectEnvelope.vue'
  import ApproveDialog from '@/components/_modules/Dashboard/widgets/ApprovalNeeded/approve-dialog'
  import AddReceipt from './AddReceipt.vue'
  import EnvelopeRejectInfo from '@/components/_modules/Programs/Card-envelopes/EnvelopeRejectInfo.vue'
  import RejectDialog from '@/components/_modules/Dashboard/widgets/ApprovalNeeded/reject-dialog'
  import he from 'he'
  import { EventBus } from '@/event-bus'
  // import { backToMap } from '@/components/Layouts/navless'
  const backToMap = {
    'EnvelopeApprovalDashboard': '/ApprovalDashboard'
  }

  export default {
    data() {
      return {
        newEnvelope: {},
        selectedProgram: {},
        suppliers: [],
        selectedSupplier: '',
        supplierOptions: [],
        selectedSuppliers: [],
        descriptions: [],
        programOptions: [],
        supplierIds: [],
        supplierFromRow: {},
        form: null,
        formKey: '',
        splitCounters: [],
        splitAmounts: [],
        programIncomplete: false,
        wrongSplitTotal: [],
        supplierIncomplete: [],
        descriptionIncomplete: [],
        attachments: [],
        attachmentIncomplete: [],
        businessUnits: [],
        costCenters: [],
        buAndCcPairs: [],
        categories: [],
        hasBu: false,
        hasCc: false,
        hasBuAndCcPair: false,
        ccIncomplete: [],
        buIncomplete: [],
        buAndCcPairIncomplete: [],
        loadedCategoriesAndBuAndCc: -1,
        categoryIncomplete: [],
        showAlertProgram: false,
        programOption: Object,
        previousSelectedProgram: Object,
        programConfirmPressed: false,
        requireReceiptDescription: false,
        draftSaved: false,
        showApproveDialog: false,
        isApproving: false,
        receiptIncomplete: false,
        approvalUsersData: {},
        readonly: true,
        preventCreateEnvelope: false,
        IsAppovalFromEditView: false,
        screen: '',
        Approvers: [],
        ApprovalNeeded: [],
        showEnvelopeRejectInfo: false,
        rejectionReason: '',
        copySplitObject: {},
        waitingApprovalStatuses: ['Open - Waiting Approval', 'Exported - Waiting Approval', 'Posted - Waiting Approval'],
        customFieldIncomplete: [],
        copiedForm: [],
        hasIncompleteField: false,
        customOptions: {},
        rejectedStatuses: ['Rejected', 'Exported - Rejected', 'Posted - Rejected'],
        showRejectDialog: false,
        isResendButtonDisabled: false,
        resendMessage: '',
        baseCustomFields: null,
        isCategoryRequired: false,
        duplicateIndexesMap: {},
        hasDuplicates: false,
        duplicateMessage: '',
        programLoader: {
          items: [],
          pageIndex: 0,
          hasMore: true,
          isLoading: false,
          searchTerm: ''
        },
        pageSize: 50
      }
    },

    components: {
      TheToolbar,
      AddTransaction,
      AddReceipt,
      ApproveDialog,
      RejectEnvelope,
      EnvelopeRejectInfo,
      RejectDialog
    },

    props: {
      selectedRows: [],
      envelope: {
        type: Object,
        default: {}
      },
      editEnvelope: {
        type: Boolean,
        default: false
      }
    },

    async created() {
      EventBus.$off('envelope-created')
      EventBus.$on('envelope-created', (envelopeNumber) => {
        var envNumber = envelopeNumber.data
        this.$notifications.notify({
          message: `Envelope ${envNumber} was created!`,
          type: 'info',
          placement: { from: 'top', align: 'center' }
        })
      })
      EventBus.$off('envelope-draft')
      EventBus.$on('envelope-draft', (envelopeNumber) => {
        var envNumber = envelopeNumber.data
        this.$notifications.notify({
          message: `Envelope ${envNumber} was saved as draft!`,
          type: 'info',
          placement: { from: 'top', align: 'center' }
        })
      })
      this.divisionName = this.singularize(this.$root.getUser.settings.Labels.DivisionName)
      this.programName = this.singularize(this.$root.getUser.settings.Labels.ProgramLabel)
      this.hasBu = this.$root.getUser.settings.HasBusinessUnit
      this.hasCc = this.$root.getUser.settings.HasCostCenter
      this.hasBuAndCcPair = this.$root.getUser.settings.UseBusinessUnitAndCostCenterMapping
      this.hasBuOrCcOrPair = this.hasBu || this.hasCc || this.hasBuAndCcPair

      try {
        if (this.envelope && Object.keys(this.envelope).length > 0) {
          if (this.envelope.EnvelopeStatus === 'Draft' ||
            (this.rejectedStatuses.includes(this.envelope.EnvelopeStatus) && this.envelope.CreatedByUserID === this.$root.getUser.$.user.UserID)) {
            this.readonly = false
          }
        } else {
          this.readonly = false
        }

        if (this.envelope && this.envelope.Id && this.envelope.Id.length > 0) {
          if (this.waitingApprovalStatuses.includes(this.envelope.EnvelopeStatus)) {
            await this.getApprovalUsers(this.envelope.Id)
          }
          await this.getTransactions(this.envelope.Id)
        }
        await this.initialize()

        for (const selectedRow of this.selectedRows) {
          let row = selectedRow.data

          if (row.ProgramId) {
            this.selectedProgram = {
              Id: row.ProgramId,
              Name: row.ProgramName,
              InternalProgramID: row.InternalProgramID
            }

            this.getCategoriesAndBuAndCc(row.ProgramId)
            break
          }
        }

        for (let i = 0; i < this.selectedRows.length; i++) {
          let row = this.selectedRows[i].data

          if (row.Supplier || row.NonEvedSupplier) {
            let supplierName = row.Supplier ? `${row.Supplier} (${row.SupplierEoNumber})` : row.NonEvedSupplier
            this.selectedSupplier = {
              Key: row.VendorId,
              Value: {
                CompanyName: supplierName,
                VendorId: row.SupplierId || -row.SupplierNetworkId
              }
            }
            this.selectedSuppliers[i] = this.selectedSupplier
          }
        }

        await this.fillEnvelopeData()
        this.showApproveDialog = this.$route.query.IsApproveEnvelopeFromEmail
        this.showRejectDialog = this.$route.query.IsRejectEnvelopeFromEmail
      } catch (error) {
        console.error('Error during component initialization:', error)
        throw error
      }
    },

    beforeCreate() {
      this.he = he
    },

    computed: {
      calculatedTotalAmount() {
        const total = this.selectedRows.reduce((total, row) => {
          return total + row.data.Amount
        }, 0)
        return total
      },

      formFields() {
        return this.form && this.form[0] ? this.form[0] : []
      },

      extraColumnsStyle() {
        return {
          width: `${200 * 4 + this.formFields.length * 50}px`
        }
      },

      title() {
        if (this.selectedRows.length > 0 && this.selectedRows[0].data) {
          if (this.envelope && this.waitingApprovalStatuses.includes(this.envelope.EnvelopeStatus)) {
            return 'Envelope Approval'
          } else {
            return 'Create Envelope'
          }
        }
        return 'Create Envelope'
      },

      isApprover() {
        return this.isUserInApprovalList()
      },

      rejectionMessage() {
        const message = `The envelope was declined for the following reason: ${this.envelope.RejectionReason}
          <br> Only ${this.envelope.CreatedByUser} can edit this envelope.`

        return message
      }
    },

    watch: {
      'envelope.FormattedLastModifiedDate': function (newValue) {
        this.getTimeFromFormatedDate(newValue)
        this.getDateFromFormatedDate(newValue)
      },
      selectedRows(newVal, oldVal) {
        this.validateDuplicates()
      }
    },

    methods: {
      async getCustomOptions(url, key) {
        try {
          const response = await this.api.get(url)
          if (response && response.data) {
            this.customOptions[key] = response.data
          }
        } catch (error) {
          console.error(error)
        }
      },

      async initialize() {
        this.splitCounters = new Array(this.selectedRows.length).fill(1)
        this.splitAmounts = this.selectedRows.map(item => parseFloat(item.data.Amount))
        this.descriptions = new Array(this.selectedRows.length).fill(null)
        this.selectedSuppliers = new Array(this.selectedRows.length).fill(null)
        this.attachments = new Array(this.selectedRows.length).fill(null)
        this.resetValidation()
      },

      async handleReasonClick(approver) {
        try {
          this.rejectionReason = approver.Reason
          this.showEnvelopeRejectInfo = true
        } catch (error) {
          console.error('There was a problem handling the button click:', error)
        }
      },

      validateDuplicates() {
        // Reset the duplicate indexes map
        this.duplicateIndexesMap = {}

        const seenIds = new Map() // Track seen transaction IDs and their original index

        this.selectedRows.forEach((row, index) => {
          const transactionId = row.data && row.data.Id

          if (seenIds.has(transactionId)) {
            // If it's a duplicate, map the current index to the original index
            const originalIndex = seenIds.get(transactionId)
            this.duplicateIndexesMap[index] = originalIndex
            this.duplicateIndexesMap[originalIndex] = originalIndex // Mark the original as well
          } else {
            // Store the first occurrence of the transactionId
            seenIds.set(transactionId, index)
          }
        })

        // Check if there are any duplicates
        this.hasDuplicates = Object.keys(this.duplicateIndexesMap).length > 0

        if (this.hasDuplicates) {
          this.preventCreateEnvelope = true
          this.duplicateMessage = [
            'The following duplicate transactions were detected:',
            // Specific duplicate enumeration
            Object.entries(this.duplicateIndexesMap)
              .filter(([index, originalIndex]) => parseInt(index) !== originalIndex) // Only message for duplicates
              .map(([index, originalIndex]) => {
                return `Transaction number ${parseInt(index) + 1} is a duplicate of transaction number ${originalIndex + 1}.`
              })
              .join(' '),
            'Please consider removing the duplicates before submitting.'
          ].join(' ')
        } else {
          this.preventCreateEnvelope = false
          this.duplicateMessage = ''
        }
      },

      async resetValidation() {
        this.programIncomplete = false
        this.wrongSplitTotal = new Array(this.selectedRows.length).fill(false)
        this.supplierIncomplete = new Array(this.selectedRows.length).fill(false)
        this.descriptionIncomplete = new Array(this.selectedRows.length).fill(false)
        this.attachmentIncomplete = new Array(this.selectedRows.length).fill(false)
        this.ccIncomplete = new Array(this.selectedRows.length).fill(false)
        this.buIncomplete = new Array(this.selectedRows.length).fill(false)
        this.buAndCcPairIncomplete = new Array(this.selectedRows.length).fill(false)
        this.categoryIncomplete = new Array(this.selectedRows.length).fill(false)
        this.customFieldIncomplete = new Array(this.selectedRows.length).fill(false)
        this.receiptIncomplete = false
        this.hasIncompleteField = false
      },

      getSupplierPlaceholder(index) {
        let row = this.selectedRows[index].data
        return row.Merchant ? row.Merchant : 'Select a supplier...'
      },

      async getTransactions(envelopeId) {
        this.screen = this.envelope.FromDashboard ? 'Dashboard' : ''
        try {
          const response = await this.api.forms.post(this.api.$.evedpaycard.transactions, {
            sort: 'EnvelopeListOrder',
            dir: 'ASC',
            start: 0,
            limit: 100,
            isLiveGrid: true,
            filter: JSON.stringify({ 'EnvelopeId': envelopeId, 'Screen': this.screen, searchTerm: '' })
          })

          if (response && response.data) {
            this.selectedRows = response.data.Data.map(item => ({ data: item }))
          }
        } catch (error) {
          console.error('Error while retrieving transactions:', error)
        }
      },

      async approveOrReject(envelopes, reason = '') {
        this.isApproving = true
        try {
          let payload = {
            envelopesData: envelopes
          }
          if (reason.length > 0) {
            payload.envelopesData[0].RejectReason = reason
          }
          this.IsAppovalFromEditView = true
          await this.createEnvelope(true)
          payload.preventError = true
          const response = await this.api.post(this.api.$.evedpaycard.approveOrRejectEnvelope, payload)
          if (!response.data) {
            throw new Error('Error during the request')
          }
          this.showApproveDialog = false
          // Redirect AFTER approval API call completes successfully
          if (this.envelope.FromDashboard || this.$route.query.IsApproveEnvelopeFromEmail === 'true' || this.$route.query.IsRejectEnvelopeFromEmail === 'true') {
            this.$emit('success')
            this.goToDashboard()
          } else {
            this.$emit('success')
          }
        } catch (error) {
          console.error(error)
          this.$notifications.notify({ type: 'plain', icon: 'exclamation-circle', placement: { from: 'top', align: 'center' }, timeout: 0, message: 'An error occurred while saving. Please try again.', discard: 'Ok', goto: '' })
        } finally {
          this.isApproving = false
        }
      },

      doApprove() {
        this.approveOrReject([this.envelope])
      },

      doReject(reason) {
        this.approveOrReject([this.envelope], reason)
      },

      async getApprovalUsers(envelopeId) {
        this.api.get(this.api.$.evedpaycard.approvalUsersForEnvelope, {
          params: {
            envelopeId
          }
        })
          .then(response => {
            this.approvalUsersData = response.data
          })
          .catch(error => {
            console.error('There was a problem with the approval users request:', error)
          })
      },

      async handleResend() {
        try {
          await this.resendEnvelopeApprovalEmail()
          this.resendMessage = 'The email was resent successfully.'
        } catch (error) {
          this.resendMessage = 'Failed to resend the email. Please try again.'
        }
        setTimeout(() => {
          this.resendMessage = ''
        }, 5000)
      },

      async resendEnvelopeApprovalEmail() {
        this.isResendButtonDisabled = true
        try {
          await this.api.post(this.api.$.evedpaycard.resendEnvelopeApprovalEmail, {
            envelopeId: this.envelope.Id
          })
        } catch (error) {
          console.error('There was a problem with the approval email resend request:', error)
          this.isResendButtonDisabled = false
        }
      },

      isUserInApprovalList() {
        const currentUserID = this.$root.getUser.$.user.UserID
        if (Array.isArray(this.approvalUsersData)) {
          return this.approvalUsersData.some(user => user.Id === currentUserID && user.IsCurrentAction)
        }
        return false
      },

      transformRows(envelope) {
        let amount = parseFloat(this.calculatedTotalAmount).toFixed(2)
        let row = {
          NeedsApproval: this.waitingApprovalStatuses.includes(envelope.EnvelopeStatus) ? 'EvedPay Envelope' : '',
          Amount: amount + ' USD'
        }
        return [row]
      },

      handleSplitAmounts(index) {
        this.selectedRows[index].form.forEach((item, rowIndex) => {
          const parsedAmount = item.Amount && this.selectedRows[index].form.length !== 1
            ? parseFloat(item.Amount)
            : (this.selectedRows[index].form.length === 1 ? parseFloat(this.selectedRows[index].data.Amount) : 0)

          // Ensure the amount is set reactively
          if (!isNaN(parsedAmount)) {
            this.$set(this.selectedRows[index].form[rowIndex], 'Amount', parsedAmount)
          }
        })

        // Make sure the split amounts are updated and Vue re-renders
        this.splitAmounts[index] = this.selectedRows[index].form.map(item => item.Amount)
        this.$forceUpdate()  // Force Vue to update the DOM
        this.$emit('split-amounts', this.splitAmounts)
      },

      handleInput(index, rowIndex, inputName, value) {
        this.$set(this.selectedRows[index].form[rowIndex], inputName, value)
        if (value) {
          this.$forceUpdate()
        }
      },

      formatDate(date) {
        const momentDateFormat = this.$root.getUser.sessionSettings.DateAndTimeFormats.MomentDateFormat
        return global.moment(date).format(momentDateFormat)
      },

      getTimeFromFormatedDate(formatedDate) {
        if (formatedDate) {
          var parts = formatedDate.split(' ')
          if (parts.length >= 2) {
            var result = parts[1]
            if (parts.length > 2) {
              result += ' ' + parts[2]
            }
            return result
          }
        }
        return ''
      },

      getDateFromFormatedDate(formatedDate) {
        if (formatedDate) {
          return formatedDate.split(' ')[0]
        }
        return ''
      },

      parseJsonDate(jsonDate) {
        return parseInt(jsonDate.match(/\d+/)[0], 10)
      },

      singularize(value) {
        return value.endsWith('s') ? value.slice(0, -1) : value
      },

      toggleSplit(index, rowIndex, selectedRow) {
        const existingRow = selectedRow.form[rowIndex]

        // Initialize Amount as 0 if the split hasn't occurred
        if (selectedRow.form.length < 2) {
          this.$set(selectedRow.form[rowIndex], 'Amount', 0)
        }

        // Clone the existing row fields
        const newRow = existingRow.map(field => ({
          Key: field.Key,
          Label: field.Label,
          Values: '', // Reset Values
          Required: field.Required,
          Type: field.Type
        }))

        this.baseCustomFields.forEach((baseObj, baseIndex) => {
          if (newRow[baseIndex]) {
            Object.keys(baseObj).forEach((key) => {
              newRow[baseIndex][key] = baseObj[key]
            })
          }
        })

        // Force reactivity
        this.$set(newRow, 'Amount', 0)

        // Add the new row in the form
        selectedRow.form.splice(rowIndex + 1, 0, newRow)

        this.$nextTick(() => {
          this.handleSplitAmounts(index)
        })

        this.splitCounters[index]++
      },

      removeSplit(index, rowIndex, selectedRow) {
        if (selectedRow.form.length > 1) {
          selectedRow.form.splice(rowIndex, 1)
          this.splitCounters[index]--
          this.handleSplitAmounts(index)
          this.$forceUpdate()
        }
      },

      copySplit(row) {
        if (row) {
          this.copySplitObject.Amount = row.Amount
          this.copySplitObject.Fields = Array.from(row)
          if (this.hasBuAndCcPair) {
            this.copySplitObject.BuAndCcPair = row.BuAndCcPair
          }
          if (this.hasBu) {
            this.copySplitObject.BusinessUnit = row.BusinessUnit
          }
          if (this.hasCc) {
            this.copySplitObject.CostCenter = row.CostCenter
          }
          this.copySplitObject.Category = row.Category
          this.copySplitObject.ReferenceId = row.ReferenceId
        }
      },

      pasteSplit(index, row) {
        if (row) {
          this.copySplitObject.Fields.forEach(field => {
            let matchingField = row.find(f => f.Key === field.Key)
            if (matchingField) {
              matchingField.Values = field.Values
            }
          })
          row.Amount = this.copySplitObject.Amount
          if (this.hasBuAndCcPair) {
            row.BuAndCcPair = this.copySplitObject.BuAndCcPair
          }
          if (this.hasBu) {
            row.BusinessUnit = this.copySplitObject.BusinessUnit
          }
          if (this.hasCc) {
            row.CostCenter = this.copySplitObject.CostCenter
          }
          row.Category = this.copySplitObject.Category
          row.ReferenceId = this.copySplitObject.ReferenceId
          this.handleSplitAmounts(index)
          this.$forceUpdate()
        }
      },

      resetSplit() {
        this.selectedRows.forEach((row, index) => {
          row.form.forEach(item => {
            item.CostCenter = null
            item.BusinessUnit = null
            item.BuAndCcPair = null
            item.Category = null
            item.ReferenceId = null
          })
          row.form = [row.form[0]]
          this.splitCounters[index] = 1
          this.handleSplitAmounts(index)
          this.$forceUpdate()
        })
      },

      formsTemplate() {
        this.selectedRows = this.selectedRows.map(row => {
          return {
            ...row,
            form: JSON.parse(JSON.stringify(this.form))
          }
        })
      },

      async getCategoriesAndBuAndCc(programId) {
        try {
          this.loadedCategoriesAndBuAndCc = 0

          const response = await this.api.get(this.api.$.evedpaycard.categoriesAndBuAndCc, {
            params: {
              programId: programId,
              invoiceId: 0,
              loadAllData: true
            }
          })

          if (response && response.data) {
            if (response.data.costCentersAndBusinessUnit) {
              this.hasBuAndCcPair = response.data.costCentersAndBusinessUnit.areCombined || this.$root.getUser.settings.UseBusinessUnitAndCostCenterMapping
              if (this.hasBuAndCcPair) {
                if (response.data.costCentersAndBusinessUnit.mixedCostCentersAndBusinessUnits) {
                  this.buAndCcPairs = response.data.costCentersAndBusinessUnit.mixedCostCentersAndBusinessUnits
                }
              } else {
                this.hasBu = response.data.costCentersAndBusinessUnit.businessUnits.length > 0 || this.$root.getUser.settings.HasBusinessUnit
                this.hasCc = response.data.costCentersAndBusinessUnit.costCenters.length > 0 || this.$root.getUser.settings.HasCostCenter
                if (this.hasBu) {
                  this.businessUnits = response.data.costCentersAndBusinessUnit.businessUnits
                }
                if (this.hasCc) {
                  this.costCenters = response.data.costCentersAndBusinessUnit.costCenters
                }
              }
            }
            if (response.data.categories) {
              this.categories = response.data.categories
            }

            this.loadedCategoriesAndBuAndCc = 1
          }
        } catch (error) {
          this.loadedCategoriesAndBuAndCc = -1
          console.warn(error)
        }
      },

      handleSupplierSelection(option, index) {
        if (option) {
          this.supplierIds[index] = option.Value.VendorId
          this.supplierIncomplete[index] = false
        }
      },

      fetchSuppliersOnOpen() {
        this.suppliers.length || this.api.get(this.api.$.evedpaycard.suppliers, {
          params: {
            q: ''
          }
        })
          .then(r => {
            if (r && r.data) {
              this.supplierOptions = r.data
              this.originalSuppliers = r.data
            }
          })
          .catch(e => console.warn(e))
      },

      async getReconcile(row, index) {
        this.programs = []
        let rowData = row.data
        const response = await this.api.get('evedpaycards/transactions/get-reconcile', {
          params: {
            transactionId: rowData.Id,
            divisionId: rowData.DivisionId
          }
        })

        if (rowData.Supplier || rowData.NonEvedSupplier) {
          let supplierName = rowData.Supplier ? `${rowData.Supplier} (#${rowData.SupplierEoNumber})` : rowData.NonEvedSupplier
          this.selectedSuppliers[index] = {
            Key: rowData.VendorId,
            Value: {
              CompanyName: supplierName,
              VendorId: rowData.SupplierId || -rowData.SupplierNetworkId
            }
          }
        }

        if (response && response.data) {
          this.descriptions[index] = response.data.ReconcileNote

          if (response.data.TransactionFiles.length > 0) {
            this.attachments[index] = response.data.TransactionFiles
          }

          this.$forceUpdate()
          this.setRowFieldsValues(response.data.TransactionFields, row, index)
        }
      },

      setAllRowsFields(reconciledMap) {
        if (this.loadedCategoriesAndBuAndCc === 0) {
          setTimeout(() => {
            this.setAllRowsFields(reconciledMap)
          }, 100)
          return
        }
        this.loadedCategoriesAndBuAndCc = -1
        this.selectedRows.forEach((row, i) => {
          let id = row.data.Id
          if (reconciledMap[id]) {
            this.setRowFieldsValues(reconciledMap[id].TransactionFields, row, i)
          }
          this.handleSplitAmounts(i)
        })
      },

      setRowFieldsValues(fieldsValues, row, rowIndex) {
        try {
          var existingRow = row.form[0]

          while (row.form.length < fieldsValues.length) {
            const newRow = existingRow.map((field) => ({ Key: field.Key, Label: field.Label, Values: '', Required: field.Required, Type: field.Type }))
            row.form.splice(rowIndex + 1, 0, newRow)
            this.splitCounters[rowIndex]++
          }

          fieldsValues.forEach((r, index) => {
            row.form[index].Amount = r.Amount
            row.form[index].ItemId = r.ItemId
            if (this.hasBuAndCcPair) {
              if (r.ProgramBusinessUnitAndCostCenter && r.ProgramBusinessUnitAndCostCenter.Id) {
                row.form[index].BuAndCcPair = this.buAndCcPairs.find(pair => pair.programBusinessUnitAndCostCenterId === r.ProgramBusinessUnitAndCostCenter.Id.toString())
              }
            } else {
              if (r.BusinessUnit && r.BusinessUnit.Id) {
                row.form[index].BusinessUnit = this.businessUnits.find(bu => bu.businessUnitId === r.BusinessUnit.Id.toString())
              }
              if (r.CostCenter && r.CostCenter.Id) {
                row.form[index].CostCenter = this.costCenters.find(cc => cc.costCenterId === r.CostCenter.Id.toString())
              }
            }
            if (r.CategoryId) {
              row.form[index].Category = this.categories.find(c => c.key === r.CategoryId.toString())
              row.form[index].ReferenceId = r.ReferenceId
            }
            r.CustomFields.forEach(field => {
              row.form[index].forEach(f => {
                if (f.Key === field.FieldId) {
                  if (f.Type === 'select') {
                    const matchedOption = this.customOptions[f.Key].find(x => x.text === field.Value)
                    if (matchedOption) {
                      this.$set(f, 'Values', matchedOption)
                    }
                  } else {
                    f.Values = row && row.data && row.data.ReconcileId ? field.Value : f.Values
                  }
                }
              })
            })
            this.$forceUpdate()
          })
          this.handleSplitAmounts(rowIndex)
        } catch (error) {
          console.error(`Error fetching field values for row ${row.data.Id}:`, error)
        }
      },

      async fetchSuppliers(query) {
        let results = await this.api.get(this.api.$.evedpaycard.suppliers, {
          params: {
            q: query || ''
          }
        })

        if (results && results.data) {
          this.supplierOptions = results.data
        }
      },

      getSelectedSupplier(e) {
        this.selectedSupplier = e.Value.VendorId
      },

      handleTransaction(fullTransactionObject) {
        if (!this.selectedProgram || Object.keys(this.selectedProgram).length === 0) {
          if (fullTransactionObject && fullTransactionObject.data && fullTransactionObject.data.ProgramId) {
            this.$nextTick(() => {
              this.$notifications.notify({
                type: 'plain',
                icon: 'exclamation-circle',
                placement: { from: 'top', align: 'center' },
                timeout: 0,
                goto: '',
                message: `By selecting this transaction, you are about to select the following ${this.programName.toLowerCase()} '${fullTransactionObject.data.ProgramName}'. Do you want to proceed?`,
                dismiss: 'Yes',
                discard: 'No',
                onClose: (dismiss) => {
                  if (dismiss === 'Yes') {
                    this.addTransaction(fullTransactionObject)
                  } else {
                    return
                  }
                }
              })
            })
          } else {
            this.addTransaction(fullTransactionObject)
          }
        } else {
          this.addTransaction(fullTransactionObject)
        }
      },

      async addTransaction(fullTransactionObject) {
        if (fullTransactionObject && fullTransactionObject.data) {
          if (fullTransactionObject.data.ProgramId) {
            this.selectedProgram = {
              Id: fullTransactionObject.data.ProgramId,
              Name: fullTransactionObject.data.ProgramName
            }
            await this.getCategoriesAndBuAndCc(fullTransactionObject.data.ProgramId)
          }

          const formArray = this.selectedRows[0].form
          // Create a deep copy of the first element and clear the Values property
          const firstElement = formArray[0]
          const copiedFirstElement = firstElement.map(field => ({
            ...field,
            Values: ''
          }))

          // Set default values
          this.baseCustomFields.forEach((baseObj, baseIndex) => {
            if (copiedFirstElement[baseIndex]) {
              Object.keys(baseObj).forEach((key) => {
                copiedFirstElement[baseIndex][key] = baseObj[key]
              })
            }
          })

          // Set the copied form array back to the reactive data
          this.copiedForm = [copiedFirstElement]
          fullTransactionObject.form = this.copiedForm
          fullTransactionObject.form.Amount = fullTransactionObject.data.Amount
          this.selectedRows.push(fullTransactionObject)
          this.splitCounters.push(1)
          this.wrongSplitTotal.push(false)
          this.supplierIncomplete.push(false)
          this.descriptionIncomplete.push(false)
          this.attachmentIncomplete.push(false)
          this.ccIncomplete.push(false)
          this.buIncomplete.push(false)
          this.buAndCcPairIncomplete.push(false)
          this.categoryIncomplete.push(false)
          this.customFieldIncomplete.push(false)
          this.descriptions.push(null)
          this.selectedSuppliers.push(null)
          this.attachments.push(null)
          this.getReconcile(fullTransactionObject, this.selectedRows.length - 1)
        }
      },

      getLabel(option) {
        return option.Value.CompanyName + (option.Value.Vci ? ' (#' + option.Value.Vci + ')' : '')
      },

      prepareEnvelope(isSent) {
        if (this.selectedRows.length === 0) {
          console.error('No data')
          return
        }

        const selectedData = this.selectedRows.map(row => row.data)

        let minDate = this.parseJsonDate(selectedData[0].TransactionDate)
        let maxDate = this.parseJsonDate(selectedData[0].TransactionDate)

        selectedData.forEach(x => {
          const transactionDate = this.parseJsonDate(x.TransactionDate)
          if (transactionDate < minDate) minDate = transactionDate
          if (transactionDate > maxDate) maxDate = transactionDate
        })

        let forms = new Array(this.selectedRows.length).fill(null)

        this.selectedRows.forEach((row, rowIndex) => {
          if (row.form && row.form[0] && Array.isArray(row.form[0])) {
            let itemIds = row.form.map(item => item.ItemId)
            const formCopy = JSON.parse(JSON.stringify(row.form))
            const updatedFields = formCopy.map(i => {
              return i.map(x => {
                if (x.Type === 'select' && x.Values && typeof x.Values === 'object') {
                  x.Values = x.Values.text
                } else if (x.Type === 'text' && x.Values && Array.isArray(x.Values) && x.Values.length > 0) {
                  x.Values = x.Values[0]
                }
                return x
              })
            })
            let form = {
              Fields: updatedFields,
              CategoryIds: row.form.map(i => i && i.Category && i.Category.key),
              ReferenceIds: row.form.map(i => i && i.ReferenceId),
              BusinessUnitIds: row.form.map(i => i && i.BusinessUnit && i.BusinessUnit.businessUnitId)
                .some(value => value !== null && value !== undefined)
                ? row.form.map(i => i && i.BusinessUnit && i.BusinessUnit.businessUnitId)
                : [],
              CostCenterIds: row.form.map(i => i && i.CostCenter && i.CostCenter.costCenterId)
                .some(value => value !== null && value !== undefined)
                ? row.form.map(i => i && i.CostCenter && i.CostCenter.costCenterId)
                : [],
              ProgramBusinessUnitAndCostCenterIds: row.form.map(i => i && i.BuAndCcPair && i.BuAndCcPair.programBusinessUnitAndCostCenterId)
                .some(value => value !== null && value !== undefined)
                ? row.form.map(i => i && i.BuAndCcPair && i.BuAndCcPair.programBusinessUnitAndCostCenterId)
                : [],
              Amounts: this.splitAmounts[rowIndex],
              TransactionReconcileSplitItemIds: itemIds
            }
            forms[rowIndex] = form
          }
        })

        this.newEnvelope = {
          Id: this.envelope ? this.envelope.Id : null,
          IsSent: isSent,
          IsAppovalFromEditView: this.IsAppovalFromEditView,
          CardId: this.selectedRows[0].data.CardId,
          ProgramId: this.selectedProgram ? this.selectedProgram.Id : null,
          StartDate: global.moment(minDate).format('YYYY-MM-DD'),
          EndDate: global.moment(maxDate).format('YYYY-MM-DD'),
          Amount: this.calculatedTotalAmount,
          TransactionIds: this.selectedRows.map(row => row.data.Id),
          SupplierIds: this.selectedSuppliers.map(supplier => supplier && supplier.Value && supplier.Value.VendorId ? supplier.Value.VendorId : null),
          Descriptions: this.descriptions,
          ReceiptFiles: this.attachments.map(att => att && att.length > 0 ? att : [{ Empty: true }]),
          CategoryIds: this.selectedRows.map(row => {
            return row.form.map(i => i && i.Category && i.Category.key)
          }),
          ReferenceIds: this.selectedRows.map(row => {
            return row.form.map(i => i && i.ReferenceId)
          }),
          BusinessUnitIds: this.selectedRows.map(row => {
            return row.form.map(i => i && i.BusinessUnit && i.BusinessUnit.businessUnitId)
          }),
          CostCenterIds: this.selectedRows.map(row => {
            return row.form.map(i => i && i.CostCenter && i.CostCenter.costCenterId)
          }),
          BusinessUnitAndCostCenterIds: this.selectedRows.map(row => {
            return row.form.map(i => i && i.BuAndCcPair && i.BuAndCcPair.programBusinessUnitAndCostCenterId)
          }),
          Forms: forms,
          FormKey: this.formKey,
          SplitAmounts: this.splitAmounts
        }
      },

      handleProgramChange(option) {
        this.selectedProgram = option !== null ? option : Object
        this.resetSplit()
        if (option && option.Id) {
          this.getCategoriesAndBuAndCc(option.Id)
        }
        this.programIncomplete = false
      },

      handleProgramInput(option) {
        if (this.previousSelectedProgram && option && this.previousSelectedProgram.Id === option.Id) {
          return
        }

        this.programOption = option
        if (this.previousSelectedProgram && this.previousSelectedProgram.Id && this.previousSelectedProgram.Name) {
          this.showAlertProgram = true
        } else {
          this.handleProgramChange(option)
        }
      },

      onSelectProgramOpen() {
        this.programLoader.searchTerm = ''
        this.loadPrograms(true)
      },

      onProgramSearch(term) {
        this.programLoader.searchTerm = term
        this.loadPrograms(true)
      },

      async loadPrograms(reset = false) {
        const loader = this.programLoader
        if (loader.isLoading) return
        if (reset) {
          loader.pageIndex = 0
          loader.items = []
          loader.hasMore = true
        }
        if (!loader.hasMore) return

        loader.isLoading = true
        try {
          const { data } = await this.api.get(
            this.api.$.evedpaycard.programs,
            {
              params: {
                divisionId: this.selectedRows[0].data.DivisionId,
                pageIndex: loader.pageIndex,
                pageSize: this.pageSize,
                searchTerm: loader.searchTerm
              }
            }
          )

          const { Items, HasMore } = data
          const mapped = Items.map(p => ({
            Id: p.ProgramId,
            Name: p.ProgramName,
            InternalProgramID: p.InternalProgramID
          }))

          loader.items = reset ? mapped : loader.items.concat(mapped)
          loader.hasMore = HasMore
          loader.pageIndex += 1

          this.programOptions = loader.items
        } catch (e) {
          console.error('loadPrograms error', e)
        } finally {
          loader.isLoading = false
        }
      },

      async fillEnvelopeData() {
        const divisionId = this.selectedRows[0].data.DivisionId
        const transactionIds = this.selectedRows.map(function(row) {
          return row.data.Id
        })

        const params = {
          transactionIds: transactionIds.join('_'),
          divisionId: divisionId
        }

        if (this.envelope && this.envelope.Id) {
          params.envelopeId = this.envelope.Id
        }

        const response = await this.api.get('evedpaycards/transactions/get-envelope', {
          params: params
        })

        if (response && response.data) {
          this.requireReceiptDescription = response.data.RequireReceiptDescription
          this.isCategoryRequired = response.data.IsCategoryRequired

          this.handleFormFieldsAndTemplate(response.data.Form)

          this.Approvers = response.data.ApproversData
          this.ApprovalNeeded = response.data.WaitingApprovalUsers

          if (this.splitCounters.length === 0) {
            this.splitCounters = new Array(this.selectedRows.length).fill(1)
          } else if (this.splitCounters.length < this.selectedRows.length) {
            this.splitCounters.push(1)
          }

          let reconciledMap = response.data.ReconciledTransactions

          this.selectedRows.forEach((row, i) => {
            let id = row.data.Id
            if (reconciledMap[id]) {
              this.descriptions[i] = reconciledMap[id].ReconcileNote
              this.attachments[i] = reconciledMap[id].TransactionFiles

              this.$forceUpdate()
            }
          })

          for (const x of this.form[0]) {
            if (x.Type === 'select') {
              this.$set(this.customOptions, x.Key, [])
              if (x.DataSource && x.DataSource.Url) {
                await this.getCustomOptions(x.DataSource.Url, x.Key)
              }
            }
          }

          this.setAllRowsFields(reconciledMap)
        }
      },

      handleFormFieldsAndTemplate(form) {
        this.formKey = form.Key
        if (form.Fieldsets && form.Fieldsets.length > 0) {
          this.form = [form.Fieldsets[0].Fields]
          this.baseCustomFields = JSON.parse(JSON.stringify(form.Fieldsets[0].Fields))
        } else {
          this.form = [[]]
          this.baseCustomFields = [[]]
        }
        this.formsTemplate()
      },

      removeTransaction(index) {
        this.selectedRows.splice(index, 1)
        this.selectedSuppliers.splice(index, 1)
        this.descriptions.splice(index, 1)
        this.splitCounters.splice(index, 1)
        this.splitAmounts.splice(index, 1)
        this.wrongSplitTotal.splice(index, 1)
        this.supplierIncomplete.splice(index, 1)
        this.ccIncomplete.splice(index, 1)
        this.buIncomplete.splice(index, 1)
        this.buAndCcPairIncomplete.splice(index, 1)
        this.categoryIncomplete.splice(index, 1)
        this.customFieldIncomplete.splice(index, 1)
        this.descriptionIncomplete.splice(index, 1)
        this.attachments.splice(index, 1)
        this.$forceUpdate()
      },

      stopCreateEnvelope() {
        this.preventCreateEnvelope = false
      },

      async validateBeforeApprove() {
        this.showApproveDialog = await this.validateEnvelope(true)
        this.preventCreateEnvelope = false
      },

      async validateEnvelope(isSent) {
        if (this.preventCreateEnvelope) {
          return
        }
        this.preventCreateEnvelope = true
        this.resetValidation()

        if (isSent) {
          if (!this.selectedProgram || Object.keys(this.selectedProgram).length === 0) {
            this.programIncomplete = true
            this.hasIncompleteField = true
          } else {
            this.programIncomplete = false
          }

          const validatedTransactionsAmounts = await this.validateAmounts()

          for (let index = 0; index < this.selectedRows.length; index++) {
            const row = this.selectedRows[index]

            this.supplierIncomplete[index] = false

            if (!this.descriptions[index] && this.requireReceiptDescription) {
              this.descriptionIncomplete[index] = true
              this.hasIncompleteField = true
            } else {
              this.descriptionIncomplete[index] = false
            }

            row.form.some(item => !item || !item.BusinessUnit || item.BusinessUnit === null) && this.hasBu && !this.hasBuAndCcPair ? this.buIncomplete[index] = this.hasIncompleteField = true : this.buIncomplete[index] = false

            row.form.some(item => !item || !item.CostCenter || item.CostCenter === null) && this.hasCc && !this.hasBuAndCcPair ? this.ccIncomplete[index] = this.hasIncompleteField = true : this.ccIncomplete[index] = false

            row.form.some(item => !item || !item.BuAndCcPair || item.BuAndCcPair === null) && this.hasBuAndCcPair ? this.buAndCcPairIncomplete[index] = this.hasIncompleteField = true : this.buAndCcPairIncomplete[index] = false

            if (this.isCategoryRequired) {
              row.form.some(item => !item || !item.Category || item.Category === null)
                ? this.categoryIncomplete[index] = this.hasIncompleteField = true
                : this.categoryIncomplete[index] = false
            } else {
              this.categoryIncomplete[index] = false
            }

            row.form.some(item =>
              item.some(field => field && field.Required && (!field.Values || field.Values.length === 0))
            ) ? this.customFieldIncomplete[index] = this.hasIncompleteField = true : this.customFieldIncomplete[index] = false

            const validatedTransaction = validatedTransactionsAmounts && validatedTransactionsAmounts.length
              ? validatedTransactionsAmounts.find(t => t.TransactionId === row.data.Id)
              : null
            const isAmountValid = validatedTransaction ? validatedTransaction.IsValid : false
            if (isAmountValid) {
              this.wrongSplitTotal[index] = false
              this.$forceUpdate()
            } else {
              this.wrongSplitTotal[index] = true
              this.$forceUpdate()
              this.hasIncompleteField = true
            }

            if (!this.attachments[index] || this.attachments[index].length === 0) {
              this.attachmentIncomplete[index] = true
              this.receiptIncomplete = true
            } else {
              this.attachmentIncomplete[index] = false
            }
          }
        }
        if (this.hasIncompleteField || this.receiptIncomplete) {
          return this.stopCreateEnvelope()
        }
        return true
      },

      async validateAmounts() {
        try {
          const transactionsToValidate = []
          this.selectedRows.forEach((row, i) => {
            transactionsToValidate.push({
              TransactionId: row.data.Id,
              TotalAmount: row.data.Amount,
              SplitAmounts: this.splitAmounts[i]
            })
          })

          const response = await this.api.post('evedpaycards/transactions/validate-amounts', {
            transactions: transactionsToValidate
          })
          if (!response.data) {
            throw new Error('Error during the request')
          }
          return response.data
        } catch (error) {
          console.error('Error verifying the amounts:', error)
          return []
        }
      },

      isCustomFieldInvalid(field, index) {
        return (!field.Values || field.Values.length === 0) && field.Required && this.customFieldIncomplete[index]
      },

      async createEnvelope(isSent = false) {
        if (!await this.validateEnvelope(isSent)) {
          return
        }
        this.prepareEnvelope(isSent)

        try {
          this.newEnvelope.preventError = true
          const response = await this.api.post(this.api.$.evedpaycard.envelope, {...this.newEnvelope})
          if (!response.data) {
            throw new Error('Error during the request')
          }
          this.programIncomplete = false
          this.preventCreateEnvelope = false
          this.selectedRows.forEach((row, rowIndex) => {
            row.form.forEach((item, i) => {
              if (!item.ItemId) {
                item.ItemId = response.data.TransationsItems[rowIndex].ItemIds[i]
              }
            })
          })

          if (isSent) {
            EventBus.$emit('envelope-created', response.data.EnvelopeNumber)
            localStorage.setItem('row-highlight', response.data.Id)
            // Skip redirect when in approval flow - let approveOrReject handle it after the approval API call
            if (!this.IsAppovalFromEditView) {
              this.envelope.FromDashboard || this.$route.query.IsApproveEnvelopeFromEmail === 'true' || this.$route.query.IsRejectEnvelopeFromEmail === 'true' ? (this.$emit('success'), this.goToDashboard()) : this.$emit('success')
            }
          } else {
            EventBus.$emit('envelope-draft', response.data.EnvelopeNumber)
            this.envelope.FormattedLastModifiedDate = response.data.FormattedLastModifiedDate
            this.envelope.Id = response.data.Id
            this.envelope.EnvelopeNumber = response.data.EnvelopeNumber
            this.envelope.EnvelopeStatus = response.data.EnvelopeStatus
            this.draftSaved = true
          }
        } catch (error) {
          console.error('Error during the request:', error)
          this.$notifications.notify({ type: 'plain', icon: 'exclamation-circle', placement: { from: 'top', align: 'center' }, timeout: 0, message: 'An error occurred while saving. Please try again.', discard: 'Ok', goto: '' })
        } finally {
          this.preventCreateEnvelope = false
        }
      },

      updateAttachmentsFiles(attachments, index) {
        this.attachments[index] = attachments
        this.attachmentIncomplete[index] = false
        const allFilesAttached = this.attachments.every(x => x && x.length > 0)
        if (allFilesAttached) {
          this.receiptIncomplete = false
        }
        this.$forceUpdate()
      },

      showWarningMessage() {
        this.$nextTick(() => {
          this.$notifications.notify({
            type: 'plain',
            icon: 'exclamation-circle',
            placement: { from: 'top', align: 'center' },
            timeout: 0,
            message: `Please select a ${this.programName.toLowerCase()} before adding items`,
            discard: 'Ok',
            goto: ''
          })
        })
      },

      goToDashboard() {
        if (window.parent !== window) {
          window.parent.postMessage({ type: 'LEGACY_GO_TO_DASHBOARD' }, '*')
          return
        }
        const page = this.$route.params.page
        if (backToMap[page]) {
          window.location.href = `${this.api.env}${backToMap[page]}`
        } else {
          this.$router.push('/d/Dashboard/MyDashboard')
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "~@/assets/sass/_variables.scss";

  .col-md-12.scroll {
    max-width: 1140px;
    overflow: auto;
  }

  .page-section {
    background-color: #fafafa !important;
  }

  .form-control {
    border-radius: 0;
    padding: 2px;
    width: calc(100% - 0.01px) !important;
  }

  .full-width-table {
    width: 100%;
    margin: 0;
    padding: 0;
    border-collapse: collapse;
  }

  .table-container {
    display: flex;
    flex-wrap: wrap;
    width: 100%;

    .col-md-6 > .extra-row {
    }
    .col-md-6 > [class^="col-"],
    .col-md-6 > .extra-row > [class^="col-"] {
      padding-left: 0;
      padding-right: 0;
    }
  }

  .col-md-6 {
    line-height: 2;
  }

  .table-row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    width: 100%;
    box-sizing: border-box;

    @include theme {
      border-bottom: 1px solid v(background);
    }
  }
  .table-row:not(.header) {
    @include theme {
      background: v(background-lightest);
    }
  }

  .table-cell {
    padding: 8px;
    box-sizing: border-box;
  }

  .header {
    padding: 5px 0;
  }

  .full-width-table th, .full-width-table td {
    padding: 2px 8px;
  }

  .total-amount {
    text-align: right;
    float: right;
    line-height: 2rem !important;
    width: auto !important;
    margin: 0 !important;
  }

  .centered-submit {
    display: block;
    margin: 0 auto;
    width: 250px;
  }

  .centered-approval {
    display: block;
    margin: 0 auto;
  }

  .bigger {
    width: 250px;
  }

  h4 {
    opacity: 0.7;
  }

  .summary {
    &.well {
      margin-top: 5px;
      margin-bottom: 10px;
      @include theme {
      background: v(canvas);
      border-color: v(background);
      }
      border-radius: 0;
      box-shadow: none;
      padding: .7em 1.5em;
    }
    thead, tfoot {
      font-size: $font-size-xsmall;
    }
    thead {
      display: none;
    }
    tfoot {
      @include theme {
      color: v(background);
      }
    }
    tbody {
      font-weight: $font-weight-bold;
      font-size: $font-size-base-lg;
    }
    td {
      &:first-child {
        padding-left: 0;
      }
      padding-left: 2.33333333%;
    }
  }

  .overview .overview-card {
    height: 100px;
    overflow: hidden;
    min-height: 0rem;
    float: right;
    margin-right: 0;
  }

  .overview {
    margin-top:2rem;
  }

  .custom-dropdown {
    margin: 0;
    width: 200px;
  }

  .table-row + .table-row {
    .custom-dropdown-supplier {
      >>> .dawnSelect {
        border-top: 0;
      }
    }
  }
  .col-md-12.no-pad + .col-md-12.no-pad {
    .custom-dropdown-supplier {
      >>> .dawnSelect {
        @include theme {
        border-top: 1px solid v(background);
        }
        margin-top: -1px;
        height: 31px;
      }
    }
    .table-row .custom-dropdown-supplier {
      >>> .dawnSelect {
        border-right: 0;
      }
    }
  }

  .custom-dropdown-supplier {
    width: 100%;
    margin: 0;
    >>> .dawnSelect {
      border-top-width: 0;
      height: 31px;
    }
    >>> .dawnSelect__content-wrapper.list {
      min-width: 340px;
    }
    >>> .dawnSelect__select {
      line-height: 1.3 !important;
    }
    >>> .dawnSelect__input {
      margin-top: 3px;
    }
    >>> input[name="supplier"][disabled]::placeholder {
      color: #333333;
    }
  }

    .table-row .custom-field-dropdown {
      >>> .dawnSelect {
        @include theme {
          border-top: 1px solid v(background);
        }
        border-right: 0;
        height: 26px;
        border-bottom: 0;
        margin: 0;
      }
    }

    .custom-field-dropdown {
      width: 100%;
      margin: 0;

      >>> .dawnSelect {
        border-top-width: 0;
        height: 26px;
      }

      >>> .dawnSelect__content-wrapper.list {
        min-width: 340px;
      }

      >>> .dawnSelect__select {
        line-height: 1.3 !important;
      }
    }

    .description-col {
      @include theme {
        border-left: 1px solid v(background);
        border-bottom: 1px solid v(background);
      }
      height: 32px;
    }

    .description-field {
      width: 100%;
      z-index: 9;
    }

    input.form-control,
    .amount-input >>> input.form-control {
      height: 32px;
      margin-top: 0px;
      margin-bottom: -1px;
    }
    .table-row + .table-row .amount-input >>> input.form-control {
      border-top: 0;
    }
    .table-row + .table-row {
      .small-input >>> input.form-control {
        height: 32px;
        margin-top: 0;
      }
    }
    .small-input {
      margin-bottom: 0;
    }
    .small-input >>> input.form-control {
      height: 32px;
      border-top: 0;
    }
    .table-row + .table-row input.form-control {
      margin-top: 0;
    }
    .table-row + .table-row .amount-input {
      margin-top: 1px;
    }
    .amount-input >>> input.form-control {
      margin-left: -1px;
    }
    .col-md-1 + .col-md-1 input.form-control {
      border-left: 0;
    }
    .description-textbox {
      width: 100%;
      margin: 0 !important;
      >>> input.form-control {
        border-top: 0;
        border-left: 0;
        border-right: 0;
        height: 32px;
      }
    }

    .amount-input {
      width: 100%;
      margin: 0;
    }

    .table-row {
      margin-top: -1px;
    }

    .remove-line {
      position: absolute;
      right: -15px;
      z-index: 9;
    }

    .remove-button {
      border: none;
      background: none;
    }

    .column-overflow {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
    .id-row {
      width: 15px !important;
    }
    .supplier-column {
      width: calc(25% + 25px) !important;
    }
    .supplier-column + [class^="col-"] {
      margin-top: -1px;
      @include theme {
        border-top: 1px solid v(background);
      }
    }
    .table-row + .table-row .supplier-column + [class^="col-"] {
      border-top: none;
    }
    .table-row.header .supplier-column + [class^="col-"] {
      border-top: none;
    }

    .col-md-6.no-pad[style^="width"] {
      .col-md-3 {
        width: 180px !important;
      }
      .col-md-2 {
        width: 100px !important;
      }
    }
    [class*="col-field-"] {
      float: right;
      width: 30px !important;
    }
    .amount-column {
      text-align: right;
      float: right;
      padding-right: 25px !important;
    }

    .amount-input {
      margin-left: 26px;
    }
    .col-md-1 {
      width: calc(8.33333333% - 10px);
    }
    .col-md-1, .col-md-2 {
      padding-left: 0;
      padding-right: 0;
    }
    .table-row:not(.header) .col-field-0 {
      @include theme {
        border-left: 1px solid v(background);
      }
    }
    .col-field-0,
    .col-field-1 {
      width: calc(8.33333333% + 5px);
    }
    .col-field-last {
      height: 30px;
      @include theme {
        border-right: 1px solid v(background);
      }
      left: -1px;
    }

    a.row-action {
      text-decoration: underline;
    }

    .dawn-page-section {
      padding: 0 !important;
      background: none !important;
    }

    .notice-alert-container {
      display: flex;
      justify-content: center;
      width: 100%;
    }

    .reject-reason-container {
      width: 100%;
    }

    .reject-reason-alert {
      align-items: left;
      justify-content: flex-start;
    }

    .notice-alert {
      display: flex;
      align-items: center;
    }

    .input-error {
      border: 1px solid red !important;
    }

    .red-border {
      border: 2px solid red;
    }

    .resend-message {
      font-style: italic;
      font-size: 0.875em;
      margin-left: 10px;
      color: #555;
    }

</style>



// WEBPACK FOOTER //
// src/components/_modules/Programs/Card-transactions/CreateEnvelope.vue